import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  CardBody    
} from "reactstrap";
import MaterialTable from "material-table";

//Components
import Header from "../../../components/Headers/Header.jsx";

// services
import { showMessage } from "../../../services/message.js";
import { api_POST } from "../../../services/api_service.js";
import { getSessionCookie} from "../../../services/session.js";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function AnaliseOrdemColetaList({history}) {
  const session = getSessionCookie();  

  const location = useLocation();  
  
  const [list_table, set_list_table] = React.useState([])

  const[list_loading, set_list_loading] = React.useState(false);
    
  const GetList = (detalhes) => {    
    set_list_loading(true);
    
    detalhes.concessionariaId = session.concessionariaId;    
    
    api_POST('AvaliacaoColeta/GetListToDashboard', detalhes).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else{
        set_list_table(result.data);
      }
    });
  }
  
  const OpenOrdemColetaMap = (data) => {    
    let url = '/mapaordem/analiseordemmap?id=' + data.ordemColetaId
    window.open(url);
  }

  const hadleBadgeStatusAvaliacao = (status) => {
    switch(status){
      case "Pendente": return "badge badge-dark";
      case "Não Avaliada": return "badge badge-default";
      case "Aprovação Automática": return "badge badge-success";
      case "Aprovada": return "badge badge-success";
      case "Contestada": return "badge badge-warning";
      case "Justificada": return "badge badge-primary";
      case "Reprovada": return "badge badge-danger";      
      default: return ""
    }
  }

  useEffect(() => {    
    if (location.state.detalhes != null)
      GetList(location.state.detalhes);                
  }, [location]);

  const columnsProp = [
    { title: 'Setor', field: "identificacaoSetor"},
    { title: 'Modalidade', field: "modalidadeColeta"},
    { title: 'Divisão Administrativa', field: "descricaoRegional"},
    { title: 'Placa/Identificação', field: "placa"},
    { title: 'Status Execução', field: "statusExecucao"},
    { title: 'Inconformidades', field: "totalInconformidades", render: (rowData) => rowData && (<span className={rowData.totalInconformidades > 0 ? "badge badge-warning" : ""}>{rowData.totalInconformidades}</span>)},
    { title: 'Status Avaliação', field: "statusAvaliacao", render: (rowData) => rowData && (<span className={hadleBadgeStatusAvaliacao(rowData.statusAvaliacao)}>{rowData.statusAvaliacao}</span>)},
    { title: 'Responsável', field: "responsavelAvaliacao"}
  ]

  return (
    <>
        <Header />
        <Container className="mt--9" fluid>             
              <Row>
                <Container className="mt-1" fluid>
                    <Card className="shadow">
                        <CardHeader className="border-0">
                          <Row>
                            <Col md="12">
                              <strong> Lista de Ordens de Serviço</strong>
                            </Col>                            
                          </Row>                          
                        </CardHeader>                            
                        <CardBody>
                        <Row>
                            <Col md="12" className="mt-1 mb-4">
                              <MaterialTable
                                title="Lista de Ordens de Serviço"
                                columns={columnsProp}
                                data={list_table}
                                isLoading={list_loading}
                                options={{...table_style, headerStyle: {zIndex: 0}}}                   
                                actions={[
                                  {
                                    icon: 'edit',
                                    tooltip: 'Analisar Ordem de Serviço',
                                    onClick: (event, rowData) => OpenOrdemColetaMap(rowData)
                                  }
                                ]}    
                                localization={table_translate}  
                              />                            
                            </Col>
                          </Row>
                      </CardBody>                                     
                    </Card>
                </Container>
              </Row>                                             

        </Container>        

    </>
  );
}
